// src/app/shared/user-data.service.ts
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from '../helpers/errorService';
import { IUserInfo } from '../models/contact';
import { EopPlanSlug } from '../../app/eop-config/eop-page-config';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  private userInfo: IUserInfo | null = null;
  private buildingId: string | null = null;
  private planSlug: EopPlanSlug | null = null;
  private hasAssess: string | null = null;
  private orgType: string | null = null;

  constructor(
      private http: HttpClient,
      private errorService: ErrorService
  ) { }

  setUserData(data: IUserInfo): void {
    this.userInfo = data;
  }

  setBuildingId(buildingId: string): void {
    this.buildingId = buildingId;
  }

  setPlanSlug(planSlug: EopPlanSlug): void {
    this.planSlug = planSlug;
  }

  setAssessStatus(hasAssess: string): void {
    this.hasAssess = hasAssess;
  }

  setOrgType(orgType: string): void {
    this.orgType = orgType;
  }

  getBuildingId(): string | null {
    return this.buildingId;
  }

  getPlanSlug(): EopPlanSlug | null {
    return this.planSlug;
  }

  getHasAssess(): string | null {
    return this.hasAssess;
  }

  getOrgType(): string | null {
    return this.orgType;
  }

  getUserData(): IUserInfo | null {
    return this.userInfo;
  }

  // Fetch user info from backend
  getUserInfo(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.userPermissions.replace(':buildingId', buildingId);      
    return this.http.get<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }
}
